module.exports = __webpack_public_path__ + "img/int6.475b7be9.jpg";